import { Link, useParams } from "react-router-dom";
import Button from '@mui/material/Button';
import testimonialImage from '../Assets/Images/testimonial-img.png';

const Testimonial = () => {

  const { id } = useParams();

  return (
    <>
      <div className="testimonial-container">
        <div className="testimonial">

          <div className="testi">
            <div className="quotation-mark">“</div>This assessment opened my eyes and prevented me from going along with the wrong ChMS because of switching costs. I never knew our team members also felt so strongly about it. It gave us the alignment needed to take the action we wanted.<div className="quotation-mark bottom"><div className="quotation-block">“</div></div>
          </div>

          <div className="avatar">
            <img src={testimonialImage} alt="pastor" />
          </div>

          <div className="designation">
            Sam Davis<br />
            <span>Executive Pastor, New Life Church</span>
          </div>
          {/* <div className="cta-btn">
          <Link to={"/invite-team/" + id} target="_blank">
          <Button>DISCOVER YOUR PRIORITY</Button>
          </Link>
        </div> */}

        </div>
      </div>
    </>
  );
}

export default Testimonial;
